import React from "react";
import webIcon from "../images/mobileapp.svg";
import mobileIcon from "../images/webdevelopment.svg";
import uiuxIcon from "../images/UX.svg";
import ecommerceIcon from "../images/e-commerce.svg";
import apiIcon from "../images/api_icon.svg";
import crmIcon from "../images/crm_icon.svg";
import cloudIcon from "../images/cloud.svg";
import zohoIcon from "../images/zoho_icon.svg";
import supportIcon from "../images/support_icon.svg";
import iosIcon from "../images/ios-icon.png";
import androidIcon from "../images/android-icon.png";
import flutterIcon from "../images/flutter-icon.png";
import blockchainIcon from "../images/blockchain-icon.png";
import angularIcon from "../images/angular-icon.png";
import laravelIcon from "../images/laravel-icon.png";
import phpIcon from "../images/php-icon.png";
import pythonIcon from "../images/python-icon.png";
import figmaIcon from "../images/figma.png";
import photoshopIcon from "../images/photoshop-icon.png";
import xdIcon from "../images/xd.png";
import illustratorIcon from "../images/Illustrator.png";
import javascriptIcon from "../images/javascript-icon.png";
import javaIcon from "../images/java-icon.png";
import nodeIcon from "../images/node.js-icon.png";

// Arrow icon SVG component
const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
  </svg>
);

// Services data array
const servicesData = [
  {
    id: 1,

    title: "Mobile App Development",
    link: "mobile app development.html",
    icon: <img src={webIcon} alt="Mobile App Development" />,
    features: [
      "Custom mobile app development (iOS, Android)",
      "Progressive web app development",
      "Cross-platform app development",
      "API integration and backend development",
    ],
    techStack: [
      { icon: iosIcon, name: "iOS" },
      { icon: androidIcon, name: "Android" },
      { icon: flutterIcon, name: "Flutter" },
      { icon: blockchainIcon, name: "Blockchain" },
    ],
  },
  {
    id: 2,
    title: "Web Development",
    link: "web development.html",
    icon: <img src={mobileIcon} alt="Web Development" />,
    features: [
      "Custom Website Development",
      "E-Commerce Website Development",
      "CMS Development (WordPress, Joomla, etc.)",
      "API Integration and Backend Development",
    ],
    techStack: [
      { icon: angularIcon, name: "Angular" },
      { icon: laravelIcon, name: "Laravel" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 3,
    title: "UI/UX Design",
    link: "web development.html",
    icon: <img src={uiuxIcon} alt="Web Development" />,
    features: [
      "User interface and user experience design",
      "Product wireframing and prototyping",
      "Mobile and web app design",
      "Interactive design and user research",
    ],
    techStack: [
      { icon: iosIcon, name: "Figma" },
      { icon: photoshopIcon, name: "Photoshop" },
      { icon: xdIcon, name: "XD" },
      { icon: illustratorIcon, name: "Illustrator" },
    ],
  },
  {
    id: 4,
    title: "E-Commerce Development",
    link: "web development.html",
    icon: <img src={ecommerceIcon} alt="Web Development" />,
    features: [
      "Custom e-commerce platform",
      "Development payment gateway",
      "Integration shopping cart and checkout systems",
      "Marketplace management and optimization",
    ],
    techStack: [
      { icon: javascriptIcon, name: "JavaScript" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 5,
    title: "API Development",
    link: "api development.html",
    icon: <img src={apiIcon} alt="API Development" />,
    features: [
      "Custom API development (RESTful & GraphQL)",
      "Secure authentication & authorization (OAuth, JWT)",
      "Scalable backend architecture",
      "Ongoing maintenance & versioning",
    ],
    techStack: [
      { icon: nodeIcon, name: "Node.js" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 6,
    title: "CRM Development",
    link: "crm development.html",
    icon: <img src={crmIcon} alt="API Development" />,
    features: [
      "Custom CRM development tailored to your business",
      "Cloud-based CRM solutions",
      "Sales and lead management systems",
      "Workflow automation and analytics features",
    ],
    techStack: [
      { icon: nodeIcon, name: "Node.js" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 7,
    title: "Cloud Solutions",
    link: "cloud solutions.html",
    icon: <img src={cloudIcon} alt="Cloud Solutions" />,
    features: [
      "Cloud infrastructure setup (AWS, Azure, Google Cloud)",
      "Cloud migration services",
      "Cloud-native app development",
      "Serverless architecture implementation",
    ],
    techStack: [
      { icon: javascriptIcon, name: "JavaScript" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 8,
    title: "Zoho",
    link: "zoho services.html",
    icon: <img src={zohoIcon} alt="Zoho" />,
    features: [
      "Zoho CRM setup and customization",
      "Zoho Creator app development",
      "Zoho Books and Zoho Invoice integration",
      "Zoho Desk and Zoho Mail setup",
    ],
    techStack: [
        { icon: nodeIcon, name: "Node.js" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
  {
    id: 9,
    title: "Development Support",
    link: "support.html",
    icon: <img src={supportIcon} alt="Development Support" />,
    features: [
      "Bug fixing and troubleshooting",
      "Performance monitoring and optimization",
      "User support and issue resolution",
      "24/7 technical support and monitoring (optional)",
    ],
    techStack: [
        { icon: nodeIcon, name: "Node.js" },
      { icon: javaIcon, name: "Java" },
      { icon: phpIcon, name: "PHP" },
      { icon: pythonIcon, name: "Python" },
    ],
  },
];

const Services = () => {
  return (
    <section className="planning-section services-section" id="services">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
            <span className="about-label">Services</span>
            <h2 className="title">Our Expertice</h2>
            <p className="sub-title text-black ">
              Hope Web Solutions offers smart, AI-powered solutions tailored to
              your business needs—driving innovation, growth, and success
              through cutting-edge technology.
            </p>
          </div>
        </div>
        <div className="services-grid">
          {servicesData.map((service) => (
            <div key={service.id} className="service-card">
              <a href={service.link}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <ul>
                  {service.features.map((feature, index) => (
                    <li key={index}>
                      <span>
                        <ArrowIcon />
                      </span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="tech-stack">
                  {service.techStack.map((tech, index) => (
                    <div key={index} className="tech-stack-name">
                      <img src={tech.icon} alt={tech.name} />
                      <h6>{tech.name}</h6>
                    </div>
                  ))}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
